import http from '../http'

const BASE_URL = 'users'

class UserSSOAPI {

  async getAllUsers() {
    const { data } = await http(`${BASE_URL}`)
    return data || []
  }

  // Listado general de usuarios del SSO (todos los roles), paginado y con
  // busqueda server-side. Cada usuario incluye su array `roles`. El SSO no
  // soporta filtrar por rol en el servidor, asi que el filtrado por rol se
  // hace en el cliente (ver UserPagination.vue).
  async getAll(page = 1, search = '', limit = 10) {
    const response = await http(`${BASE_URL}?limit=${limit}&page=${page}&search=${search}`)
    return response || null
  }

  async getAllAdmin(page = 1, search = '', limit = 0) {
    let url = `${BASE_URL}/admin`
    if (page) {
      url = url + `?limit=${limit}&page=${page}&search=${search}`
    }
    const response = await http(url)
    return response || null
  }

  async getUser(userId) {
    const { data } = await http(`${BASE_URL}/${userId}`)
    return data || {}
  }

  async get(userID) {
    const response = await http(`${BASE_URL}/${userID}`)
    return response || null
  }

}

export default new UserSSOAPI()